import React from "react";
import {  useSiteRuntime } from "../../store/realtimeSlice.js";
import { useHwaddrAndNetworkIdFromRouter, useZones } from "../../store/panelsSlice.js";


export function ZoneBadge(props) {
    return <div className="zone-badge" title={props.name}>
        <small>Zone</small>
        <span className="zone-circle">{props.id + 1}</span>
    </div>
}

export function RuntimeDisplay() {
    const runtime = useHwaddrAndNetworkIdFromRouter(useSiteRuntime);

    const zoneData = useHwaddrAndNetworkIdFromRouter(useZones);

    if (!runtime) {
        return <p>Loading runtime display...</p>;
    }
    return <div className="row">
        <div className="col-md-4 col-sm-6 col-xs-12">
            <div className="panel panel-danger">
                <div className="panel-heading"><span className="icon-event-fire"></span> Fires</div>
                <div className="panel-body" id="fire-zones">
                    {runtime.zones.fire.map(z => <ZoneBadge key={z} id={z} name={zoneData[z].name} />)}
                    {runtime.zones.fire.length == 0 ?
                        <p className="empty-msg">No zones currently on fire</p>
                        :
                        null}
                </div>
            </div>
        </div>
        <div className="col-md-4 col-sm-6 col-xs-12">
            <div className="panel panel-warning">
                <div className="panel-heading"><span className="icon-event-warn"></span> Faults</div>
                <div className="panel-body" id="fault-zones">
                    {runtime.zones.fault.map(z => <ZoneBadge key={z} id={z} name={zoneData[z].name} />)}
                    {runtime.zones.fault.length == 0 ?
                        <p className="empty-msg">No zones currently in fault</p>
                        :
                        null}
                </div>
            </div>
        </div>
        <div className="col-md-4 col-sm-6 col-xs-12">
            <div className="panel panel-inverse">
                <div className="panel-heading"><span className="icon-gear"></span> General</div>
                <div className="panel-body">
                    <p className="empty-msg">
                        {/*
                        {runtime.local.daynight ?
                        `Day/Night active: ${(runtime.local.daytime ? "Daytime" : "Nighttime")}`
                        :
                        "Day/Night settings disabled."}
                        */}
                        Day/Night settings disabled.
                    </p>
                    {runtime.disabled.sounders ?
                        <div id="sounder-disabled">
                            <span className="fa-stack fa-lg">
                                <i className="fa fa-circle fa-stack-2x"></i>
                                <i className="fa fa-bell-slash-o fa-stack-1x fa-inverse"></i>
                            </span> Sounder disabled
                        </div>
                        :
                        null}
                </div>
            </div>
        </div>
    </div>;
}
